<template>
    <v-app-bar
      app      
      color="primary"
      v-if="enabled">

      <v-app-bar-nav-icon @click="modifySidebar(!sideBarStatus)"></v-app-bar-nav-icon>   
      <v-toolbar-title class="text-uppercase">
        <span>Tooth</span>
        <span class="font-weight-light">Case</span>
      </v-toolbar-title>
          
      <v-spacer/>
      
      <v-layout fill-height mt-2 mb-2>
        <v-container ma-0 pa-0>
          <quick-treatment-search
          label="Search Dental Treatment Reference"
          :orgId="localUserDb.orgid"
          :uid="localUserDb.uid"
          :focusEffect="true"
          type="NavBar Search"></quick-treatment-search>
        </v-container>
      </v-layout>
    </v-app-bar>
</template>

<script>
import QuickTreatmentSearch from './../Treatments/Search/QuickTreatmentSearch.vue'

  export default {
    data () {
      return {
        localUserDb: {}
      }
    },
    components: {
      QuickTreatmentSearch
    },
    props: 
    {
      mini: Boolean,
      enabled: Boolean,
      userDb: Object
    },
    methods: {
      modifySidebar(newStatus) {
        this.sideBarStatus = newStatus;
        console.log("Emitted!"); // eslint-disable-line no-console
        this.$emit("sidebarEmit", newStatus);
      },
      searchFocused(){
      }
    },
     computed: {
      sideBarStatus: {
        get(){
          return this.mini;
        },
        set(newStatus) {
        return newStatus;
        }
      }
    },
    watch: {
        userDb: {
        // the callback will NOT be called immediately after the start of the observation
        immediate: true,
        handler (val) {
            if (val !== null){
                this.localUserDb = val;
            }
        }
      },
    }
  }
</script>